<template>
  <v-card class="elevation-1 pa-3 login-card mx-auto mt-8" max-width="500">
    <v-card-text>
      <div class="layout column align-center">
        <h1 class="flex my-4 primary--text font-weight-bold">ログイン</h1>
      </div>
      <v-form ref="loginForm">
        <v-text-field
          name="login"
          label="メールアドレス"
          type="text"
          v-model="model.email"
          :counter="128"
          :rules="emailRules"
          required
        ></v-text-field>
        <v-text-field
          name="password"
          label="パスワード"
          id="password"
          type="password"
          v-model="model.password"
          :counter="32"
          :rules="passwordRules"
          required
          @keyup.enter="login"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <div class="login-btn ma-6">
      <v-btn block color="primary" @click="login" :loading="loading">ログイン</v-btn>
    </div>
  </v-card>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Signin",
  data: () => ({
    loading: false,
    emailRules: [
      v => !!v || "メールアドレスは必須項目です。",
      v =>
        (v && v.length <= 128) ||
        "メールアドレスは128文字以内で入力してください。",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "メールアドレスの形式が正しくありません。"
    ],
    passwordRules: [
      v => !!v || "パスワードは必須項目です。",
      v => (v && v.length <= 32) || "パスワードは32文字以内で入力してください。"
    ],
    model: {
      email: "",
      password: ""
    }
  }),
  beforeCreate() {
    this.$store.dispatch("doUpdate", false);
    var self = this;
    firebase.auth().onAuthStateChanged(user => {
      //リロード後に実行したい処理
      if (user) {
        this.$store.dispatch("doUpdate", true);
        self.$router.push("home");
      }
    });
  },

  methods: {
    login: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.model.email, this.model.password)
        .then(user => {
          console.log(user);
          this.$store.dispatch("doUpdate", true);

          this.$router.push("/");
        })
        .catch(error => {
          alert(error.message);
        });
    },
    logoutUser() {
      firebase.auth().signOut();
    }
  }
};
</script>

<style scoped>
</style>